export const styles = {
  approved: 'ShiftCell_approved',
  unapproved: 'ShiftCell_unapproved',
} as const
